import { ElMessage } from "element-plus";

export const errorMessage = (message) => {
  ElMessage({
    showClose: true,
    message: message,
    grouping: true,
    type: "error",
    duration:3000
  });
};
export const successMessage = (message) => {
  ElMessage({
    showClose: true,
    message: message,
    grouping: true,
    type: "success",
  });
};

export const warningMessage = (message) => {
  ElMessage({
    showClose: true,
    message: message,
    grouping: true,
    type: "warning",
  });
};
